import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { EmailJSResponseStatus } from '../models/EmailJSResponseStatus';
import { store } from '../store/store';
export var sendPost = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, data) {
    var headers,
        response,
        message,
        responseStatus,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _context.next = 3;
            return fetch(store.origin + url, {
              method: 'POST',
              headers: headers,
              body: data
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.text();

          case 6:
            message = _context.sent;
            responseStatus = new EmailJSResponseStatus(response.status, message);

            if (!response.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", responseStatus);

          case 10:
            throw responseStatus;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendPost(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();